import {
  Divider,
  Stack,
  Typography
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import { StyledModal } from "./EditionInProgressWarningModal.styles";
import { ButtonDigited } from "../Button/Button.variants";

export function EditionInProgressWarningModal({
  open,
  onClose,
  onConfirm
}: {
    open: boolean
    onClose: () => void
    onConfirm?: () => void
}) {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <StyledModal
      aria-labelledby="modal-edition-in-progress-warning"
      open={ open }
      sx={ {
        padding: "2rem !important"
      } }
      onClose={ onClose }
    >
      <Stack
        alignItems="center"
        gap="1.25rem"
        sx={ { "&:focus-visible": { outline: "none" } } }
      >
        <TriangleAlert
          color={ theme.customColors.exploreCardText }
          size="3rem"
        />

        <Typography
          aria-labelledby="modal-modal-title"
          color={ theme.customColors.exploreCardText }
          variant="h2"
          fontSize="1.5rem"
          lineHeight="1.5rem"
          fontWeight={ 600 }
          sx={ { textAlign: "center" } }
        >
          { t("edition_in_progress_warning_title") }
        </Typography>

        <Typography
          aria-describedby="modal-modal-description"
          color={ theme.customColors.exploreCardText }
          fontSize="0.875rem"
          lineHeight="1.25rem"
          sx={ { textAlign: "center", whiteSpace: "pre-line" } }
        >
          { t("edition_in_progress_warning_description") }
        </Typography>

        <Divider
          sx={ {
            borderColor: theme.customColors.border,
            width: "100%"
          } }
        />

        <Stack
          direction="row"
          gap={ 2 }
          sx={ { width: "100%" } }
        >
          <ButtonDigited
            typology={ "secondary" }
            text={ t("annul") }
            onClick={ onClose }
            sx={ { flex: 1 } }
          />
          <ButtonDigited
            typology={ "primary" }
            text={ t("confirm") }
            onClick={ onConfirm }
            sx={ { flex: 1 } }
          />
        </Stack>
      </Stack>
    </StyledModal>
  );
}
